var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnCaution24Rectangle = function SvgLightIcnCaution24Rectangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.137 3.407a1 1 0 0 1 1.726 0l8.839 15.087A1 1 0 0 1 20.839 20H3.161a1 1 0 0 1-.863-1.506zm.013 6.953.215 3.231q.06.627.201.934t.504.307a.53.53 0 0 0 .51-.317q.155-.317.202-.91l.29-3.326q.045-.459.046-.904 0-.756-.195-1.157t-.772-.401q-.477 0-.77.313-.291.314-.292.874 0 .411.06 1.356m.245 7.403q.306.267.715.267.404 0 .706-.27t.302-.742a.96.96 0 0 0-.299-.712 1 1 0 0 0-.722-.293.97.97 0 0 0-.716.293.97.97 0 0 0-.292.712q0 .48.306.745",
    clipRule: "evenodd"
  })));
};
export default SvgLightIcnCaution24Rectangle;